module.exports = __webpack_public_path__ + "media/images/app/products/index/banner-all-b2ce7f585e6869823dea4ae93d496697.webp";